import { type FC } from 'react';

import { toast } from 'sonner';

import { Button, ButtonProps } from '@/components/shadcn/ui/button';
import { cn } from '@/utils';

import { useTronWallet } from '../../provider';

import { ConnectedTronWalletButton } from './components';

export const ConnectedTronWallet: FC<ButtonProps> = ({ className, children, ...props }) => {
  const { connect, isConnected } = useTronWallet();

  if (!isConnected) {
    return (
      <Button
        variant="secondary"
        size="sm"
        className={cn('font-cocogoose rounded-xl text-sm font-bold', className)}
        onClick={() => {
          void connect().catch((error) => {
            toast.error(error.message);
          });
        }}
        {...props}
      >
        {children || 'Connect Tron Wallet'}
      </Button>
    );
  }

  return (
    <ConnectedTronWalletButton {...props} className={className}>
      {children}
    </ConnectedTronWalletButton>
  );
};
